export class Config {
  // baseUrl = "http://localhost:8000";
  // http://127.0.0.1/
  // baseUrl = "http://dosmartqa.stagsoftware.net:3005"; // app runs at 3005 port number for PROD build
  baseUrl = "http://dosmartqa.stagsoftware.net:3009"; // app runs at 3009 port number for DEV build
  exportReportContent = {
    entitiesSubHeader: "All Entities of",
    SubHeaderTitle: "The list of",
  }
  exportReportParams = {
    projectSum: ["projectSum"],
    designSum: ["designSum"],
    userList: ["Persona"],
    EUTList: ["Modules", "Persona", "Features", "Requirements", "Flows", "Unspecified", "Attributes", "Environments"],
    MAPS: ["PersonaMapper", "InteractionMapper", "ScopeMapper", "EnvironmentMapper"],
    Suites: ["Suites"],
    Summary: ["Manager"],
  }
  mindMapLayoutStructureComponents = [
    {
      name: "persona",
      sections: []
    },
    {
      name: "environment",
      sections: []
    },
    {
      name: "attributes",
      sections: [
        "Migration (Mi)",
        "Installation (In)",
        "Configuration (Co)",
        "System Integration (Si)",
        "Performance (Pf)",
        "Security (Se)",
        "Load (Lo)",
        "Reliability (Re)",
        "Usability (Us)",
        "Browser Compatibility (Bc)",
        "Environment Compatibility (Ec)",
        // "Requirement Behaviour (Rb)",
        // "Flow Behaviour (Fb)",
        // "Feature Behaviour (Fe)",
        "Access Control (Ac)",
        "UI Interface (Ui)",
        "Structural Behaviour (St)",
        // "Data Validation (Dt)"
      ]
    },
    {
      name: "entities",
      sections: [
        "Feature",
        "Requirement",
        "Flow"
      ]
    }
  ]
  levelWidgetMapping = {
    "User": {
      type: "",
      category: ""
    },
    "Deployment": {
      type: "Test",
      category: ""
    },
    "Attributes": {
      type: "Test",
      category: ""
    },
    "Environment": {
      type: "Test",
      category: ""
    },
    "Flow": {
      type: "Requirement",
      category: ""
    },
    "Behaviour": {
      type: "Feature",
      category: ""
    },
    "Structure": {
      type: "Component",
      category: ""
    },
    "Interface": {
      type: "Component",
      category: ""
    },
    "Input": {
      type: "Field",
      category: ""
    }
  }
  noDataMsg = {
    emptyPersona: "There are no personas/requirements yet to map.",
    emptyEUTs: "Yet there are no entities to map.",
    emptyAttributes: "Yet there are no attributes to map.",
    emptyEnvironments: "Yet there are no environment elements to map.",
    emptyDeepDive: "Yet there are no entities to map.",
    emptyDesigner: "Yet there are no entities to map.",
    emptyExecutor: "Yet there are no environment elements/entities to map.",
    emptyTestManager: "Yet there are no personas/entities to map.",
    emptyEUTsDashboard: "Yet there is no dashboard data to show."
  }
  levels = ["L8", "L7", "L6", "L5", "L4", "L123"];
  mindMapExpandLength = "10";
  listofFunctionalityTestTypes = [
    {
      name: "Feature Behaviour",
      symbol: "Fe",
      level: "L4",
      eType: 'TF',
    },
    {
      name: "Requirement Behaviour",
      symbol: "Rb",
      level: "L5",
      eType: 'UR',
    },
    {
      name: "Flow Behaviour",
      symbol: "Fb",
      level: "L5",
      eType: 'BF',
    }
  ]
  listOfAttributes = [{
    name: "Migration",
    symbol: "Mi",
    level: "L8"
  },
  {
    name: "Installation",
    symbol: "In",
    level: "L8"
  },
  {
    name: "Configuration",
    symbol: "Co",
    level: "L8"
  },
  {
    name: "System Integration",
    symbol: "Si",
    level: "L8"
  },
  {
    name: "Performance",
    symbol: "Pf",
    level: "L7"
  },
  {
    name: "Load",
    symbol: "Lo",
    level: "L7"
  },
  {
    name: "Reliability",
    symbol: "Re",
    level: "L7"
  },
  {
    name: "Security",
    symbol: "Se",
    level: "L7"
  },
  {
    name: "Usability",
    symbol: "Us",
    level: "L7"
  },
  {
    name: "Browser Compatibility",
    symbol: "Bc",
    level: "L6"
  },
  {
    name: "Environment Compatibility",
    symbol: "Ec",
    level: "L6"
  },
  {
    name: "Access Control",
    symbol: "Ac",
    level: "L4"
  },
  {
    name: "UI Interface",
    symbol: "Ui",
    level: "L123"
  },
  {
    name: "Structural Behaviour",
    symbol: "St",
    level: "L123"
  },
    // {
    //   name: "Data Validation",
    //   symbol: "Dt",
    //   level: "L123"
    // }
  ]
  listOfAttributesUpdated = [
    {
      "name": "Load & Stress",
      "symbol": "Ls",
      "level": "L7",
      "placeholder": "Expectations on typical/max load and extreme(stress)"
    },
    {
      "name": "Performance",
      "symbol": "Pf",
      "level": "L7",
      "placeholder": "Response time(time)or throughput (#/time)"
    },
    {
      "name": "Security",
      "symbol": "Se",
      "level": "L7",
      "placeholder": "Expectations on security of storage and transfer of data"
    },
    {
      "name": "Usability",
      "symbol": "Us",
      "level": "L7",
      "placeholder": "Expectations on ease of usage of the system"
    },
    {
      "name": "Compatibility",
      "symbol": "Cm",
      "level": "L6",
      "placeholder": "Expectations of various environments to support(HW/SW)"
    },
    {
      "name": "Volume",
      "symbol": "Vo",
      "level": "L7",
      "placeholder": "Large data handling size requirements"
    },
    {
      "name": "Reliability",
      "symbol": "Re",
      "level": "L7",
      "placeholder": "Expectations on time duration of no major failures(down/up time)"
    },
    {
      "name": "Migration",
      "symbol": "Mi",
      "level": "L8",
      "placeholder": "Expectations of what earlier versions to be migrated"
    }
  ]




  lang = "en"
  // redirectHostAddress: "http://dosmartqa.stagsoftware.net:3005/#!/",
  // redirectHostAddress= "http://localhost:8000/#!/";
  request = {
    login: {
      url: "/ist/api/login"
    },
    register: {
      url: "/ist/api/register"
    },
    resendEmailverifylink: {
      url: "/ist/api/resendEmailverifylink"
    },
    emailVerification: {
      url: "/ist/api/verifyEmail"
    },
    verifyEmailExpiryLink: {
      url: "/ist/api/verifyEmaillink"
    },
    resetPassword: {
      url: "/ist/api/resetPassword"
    },
    changePassword: {
      url: "/ist/api/changePassword"
    },
    updatePassword: {
      url: "/ist/api/updatePassword"
    },
    activityLog: {
      url: "/ist/api/updateActivity"
    },
    getGroups: {
      url: "/ist/api/getGroupsByUser"
    },
    getpublicChecklists: {
      url: "/ist/api/getpublicChecklists"
    },
    deleteChecklist: {
      url: "/ist/api/deleteChecklist"
    },
    getPrivateChecklistData: {
      url: "/ist/api/getChecklistContent"
    },
    getPublicChecklistData: {
      url: "/ist/api/getpublicChecklistContent"
    },
    updatePlanName: {
      url: "/ist/api/updatePlanName"
    },
    addTaskPlanner: {
      url: "/ist/api/addTaskforPlanner"
    },
    getTaskPlanner: {
      url: "/ist/api/getTasks"
    },
    getMyTaskPlanner: {
      url: "/ist/api/getTasksByUser"
    },
    updateTaskStatus: {
      url: "/ist/api/updateTaskStatus"
    },
    deleteTaskPlanner: {
      url: "/ist/api/deleteTask"
    },
    updateTaskPlanner: {
      url: "/ist/api/updateTask"
    },
    getUsers: {
      url: "/ist/api/getUsersByOrg"
    },
    getUsersByOrgProjectID: {
      url: "/ist/api/getUsersByOrgProjectID"
    },
    updateUsers: {
      url: "/ist/api/updateUsersByProject"
    },
    getUsersByOrgProject: {
      url: "/ist/api/getUsersByOrgAndProject"
    },
    getUsersByProject: {
      url: "/ist/api/getUsersByProject"
    },
    createGroup: {
      url: "/ist/api/createGroup"
    },
    inviteUser: {
      url: "/ist/api/addUserToOrg"
    },
    checkUserExistsinSystem: {
      url: "/ist/api/checkUserExistsinSystem"
    },
    acceptInvitation: {
      url: "/ist/api/addUserToInvitedOrg"
    },
    removeUser: {
      url: "/ist/api/removeUser"
    },
    addUsersToProject: {
      url: "/ist/api/addUsersToProject"
    },
    updateUsersToProject: {
      url: "/ist/api/updateUsersByProject"
    },
    removeUserFromOrg: {
      url: "/ist/api/removeUserFromOrg"
    },
    orgAdminChange: {
      url: "/ist/api/changeOrgAdmin"
    },
    resource: {
      url: "/ist/api/resource/"
    },
    videolink: {
      url: "/ist/api/videolink/"
    },
    project: {
      url: "/ist/api/project/"
    },
    newLoginUpdate: {
      url: "/ist/api/newLoginUpdate"
    },
    addHistorySession: {
      url: "/ist/api/addHistory"
    },
    updateHistorySession: {
      url: "/ist/api/updateHistory"
    },
    getHistorySession: {
      url: "/ist/api/getHistory"
    },
    addNotification: {
      url: "/ist/api/addNotification"
    },
    getAllNotifications: {
      url: "/ist/api/getAllNotifications"
    },
    getNotifications: {
      url: "/ist/api/getNotificationsCount"
    },
    deleteActiveUser: {
      url: "/ist/api/deleteActiveUser"
    },
    removeActiveProject: {
      url: "/ist/api/removeActiveProject"
    },
    updateActiveProject: {
      url: "/ist/api/updateActiveProject"
    },
    getAllPublicWidgets: {
      url: "/ist/api/getpublicWidgets"
    },
    getAllPrivateWidgets: {
      url: "/ist/api/getprivateWidgets"
    },
    getpublicWidgetContentByID: {
      url: "/ist/api/getpublicWidgetContentByID"
    },
    getPrivateWidgetContentByID: {
      url: "/ist/api/getPrivateWidgetContentByID"
    },
    usePrivateWidget: {
      url: "/ist/api/updateprivateWidgetUseByID"
    },
    usePublicWidget: {
      url: "/ist/api/updatepublicWidgetUseByID"
    },
    getDesignerContent: {
      url: "/ist/api/getDesignerContent"
    },
    updateDesignerContent: {
      url: "/ist/api/addDesignerContent"
    },
    // getPublicWidgets: {
    //   url: "/ist/api/getpublicWidgets"
    // },
    // getPrivateWidgets: {
    //   url: "/ist/api/getPrivateWidgets"
    // },
    widgetUse: {
      url: "/ist/api/widgetUse"
    },
    session: {
      url: "/ist/api/session/"
    },
    template: {
      url: "/ist/api/template/"
    },
    uisetting: {
      url: "/ist/api/uisetting/"
    },
    entity: {
      url: "/ist/api/entity/"
    },
    scenario: {
      url: "/ist/api/scenario/"
    },
    rundata: {
      url: "/ist/api/rundata/"
    },
    publicRepositoryServer: {
      url: "https://platform.stagsoftware.net/wp-json/jwt-auth/v1/token/",
      params: {
        username: "username",
        password: "password"
      }
    },
    publicWidgetRepository: {
      url: "http://platform.stagsoftware.net/wp-json/wp/v2/posts/",
      params: {
        offset: 0,
        per_page: 100
      }
    }
  }
  states = {
    login: "login",
    main: "main"
  }
  UIstates = {
    personaMapper: { 'TF': [], 'UR': [], 'BF': [], 'XX': [] },
    scopeMapper: { 'TF': [], 'UR': [], 'BF': [], 'XX': [] },
    interactionMapper: {
      x: { 'TF': [], 'UR': [], 'BF': [], 'XX': [] },
      y: { 'TF': [], 'UR': [], 'BF': [], 'XX': [] },
    }
  }
  projectSaveLocations = ['Local', 'Google drive', 'Dropbox'];
  questionTypes = ["Default", "Custom"];
  assistantModels = ['text-davinci-003', 'curie', 'babbage', 'gpt-3.5-turbo-instruct'];
  questionsAnswers = [
    {
      question: "Who are the potential users of the feature?",
      answer: "<p><span style=\"color: rgb(55, 65, 81);\">1.    </span><strong style=\"color: rgb(55, 65, 81);\">Inventory Managers:</strong><span style=\"color: rgb(55, 65, 81);\"> As stated in the user story, the primary user of this feature would be the Inventory Manager. They are responsible for overseeing the inventory levels, ensuring that stock quantities are accurate, and maintaining the integrity of the inventory data.</span></p><p><span style=\"color: rgb(55, 65, 81);\">2.    </span><strong style=\"color: rgb(55, 65, 81);\">Warehouse Supervisors:</strong><span style=\"color: rgb(55, 65, 81);\"> Warehouse supervisors may also use this feature to keep track of stock levels and make informed decisions related to inventory management within their specific warehouse.</span></p><p><span style=\"color: rgb(55, 65, 81);\">3.    </span><strong style=\"color: rgb(55, 65, 81);\">Retail Store Managers:</strong><span style=\"color: rgb(55, 65, 81);\"> For businesses with multiple retail locations, store managers may use this feature to check the stock levels in their respective stores and request replenishments as needed.</span></p><p><span style=\"color: rgb(55, 65, 81);\">4.    </span><strong style=\"color: rgb(55, 65, 81);\">Purchasing Managers:</strong><span style=\"color: rgb(55, 65, 81);\"> Purchasing managers could use the \"View Inventory Stock\" feature to identify low stock levels of specific items, enabling them to place timely orders to replenish inventory and avoid stockouts.</span></p><p><span style=\"color: rgb(55, 65, 81);\">5.    </span><strong style=\"color: rgb(55, 65, 81);\">Accounting or Finance Teams:</strong><span style=\"color: rgb(55, 65, 81);\"> These teams might use this feature to cross-check inventory records with financial statements and ensure that the inventory's value is accurately reflected in the company's financial records.</span></p><p><span style=\"color: rgb(55, 65, 81);\">6.    </span><strong style=\"color: rgb(55, 65, 81);\">Production Managers:</strong><span style=\"color: rgb(55, 65, 81);\"> In manufacturing settings, production managers could use this feature to check the availability of raw materials and components necessary for production planning.</span></p><p><span style=\"color: rgb(55, 65, 81);\">7.    </span><strong style=\"color: rgb(55, 65, 81);\">Logistics or Supply Chain Managers:</strong><span style=\"color: rgb(55, 65, 81);\"> These managers could use this feature to monitor inventory levels at different points along the supply chain and optimize inventory flow.</span></p><p><span style=\"color: rgb(55, 65, 81);\">8.    </span><strong style=\"color: rgb(55, 65, 81);\">Business Owners or Executives:</strong><span style=\"color: rgb(55, 65, 81);\"> Business owners or executives might use this feature to get an overview of overall inventory levels and make high-level strategic decisions related to inventory investments and management.</span></p><p><span style=\"color: rgb(55, 65, 81);\">9.    </span><strong style=\"color: rgb(55, 65, 81);\">Auditors:</strong><span style=\"color: rgb(55, 65, 81);\"> Internal or external auditors might use this feature to verify inventory records during auditing processes to ensure compliance and accuracy.</span></p><p><span style=\"color: rgb(55, 65, 81);\">It is essential for the feature to be user-friendly and provide relevant information tailored to the needs of these potential users to effectively manage inventory levels and ensure stock quantity and integrity.</span></p><p><br></p>"
    },
    {
      question: "What could be non-functional attributes that are important for the feature?",
      answer: "<p>Attributes that are important for the \"View Inventory Stock\" feature to effectively serve the needs of the Inventory Manager and guarantee stock quantity and integrity include:</p><p>1.    <strong>Real-time Data:</strong> The feature should provide up-to-date and real-time inventory data to reflect the current stock levels accurately.</p><p>2.    <strong>Inventory Accuracy:</strong> It is crucial that the inventory data displayed is precise and matches the actual physical inventory in the warehouse or storage locations.</p><p>3.    <strong>Stock Availability:</strong> The feature should clearly indicate the availability of each item in the inventory, distinguishing between items in stock, out of stock, or on order.</p><p>4.    <strong>Stock Levels:</strong> The system should show the exact quantity of each item available in the inventory to help Inventory Managers make informed decisions.</p><p>5.    <strong>Product Information:</strong> The feature should display relevant information about each product, such as product name, SKU, description, and any other necessary details.</p><p>6.    <strong>Categorization and Filtering:</strong> Inventory Managers should be able to categorize and filter inventory items based on attributes like category, supplier, location, etc., to easily find and manage specific subsets of inventory.</p><p>7.    <strong>Search Functionality:</strong> The feature should offer a robust search capability, allowing the Inventory Manager to quickly locate specific items based on keywords or SKU numbers.</p><p>8.    <strong>Visual Presentation:</strong> The inventory data should be presented in a visually clear and concise manner, using graphs, charts, or tables to aid in understanding stock levels at a glance.</p><p>9.    <strong>Alerts and Notifications:</strong> The system should notify the Inventory Manager of critical events, such as low stock levels or items reaching reorder points, to proactively manage inventory.</p><p>10. <strong>Audit Trail:</strong> The feature should maintain an audit trail of inventory view activities, recording who accessed the data and when, for traceability and accountability purposes.</p><p>11. <strong>User Permissions:</strong> Access to the inventory data should be controlled through user permissions, ensuring that only authorized personnel can view sensitive information.</p><p>12. <strong>Data Export:</strong> The ability to export inventory data into various formats (e.g., CSV, Excel) is helpful for further analysis and reporting.</p><p>13. <strong>Data Integration:</strong> The feature should seamlessly integrate with other inventory management systems or modules to ensure data consistency and reduce data entry duplication.</p><p>14. <strong>Mobile Responsiveness:</strong> If the Inventory Manager needs to access inventory data on the go, the feature should be optimized for mobile devices to provide a smooth user experience.</p><p>15. <strong>Performance:</strong> The feature should be fast and responsive, even when dealing with large inventories, to minimize waiting times and enhance productivity.</p><p>16. <strong>User Training and Support:</strong> Adequate training and user support resources should be available to help Inventory Managers effectively utilize the feature and address any questions or issues.</p><p>By incorporating these attributes into the \"View Inventory Stock\" feature, Inventory Managers can confidently manage and guarantee the stock quantity and integrity of the available inventories.</p>"
    },
    {
      question: "What are the conditions to be considered that are govern the functional behaviour of the feature?",
      answer: "<p><span style=\"color: rgb(55, 65, 81);\">The functional behavior of the \"View Inventory Stock\" feature can be governed by various conditions that dictate how the feature should work and what it should deliver to meet the needs of the Inventory Manager. Some of the key conditions to be considered are:</span></p><p><span style=\"color: rgb(55, 65, 81);\">1.    </span><strong style=\"color: rgb(55, 65, 81);\">User Authentication:</strong><span style=\"color: rgb(55, 65, 81);\"> Only authenticated and authorized Inventory Managers should have access to view the inventory stock. Proper user authentication and role-based access control should be implemented.</span></p><p><span style=\"color: rgb(55, 65, 81);\">2.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Source:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should retrieve inventory data from a reliable and up-to-date source, such as a centralized inventory management system or database.</span></p><p><span style=\"color: rgb(55, 65, 81);\">3.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Visibility:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should display inventory data that the Inventory Manager is allowed to see based on their access level. Sensitive or restricted data may not be visible to all users.</span></p><p><span style=\"color: rgb(55, 65, 81);\">4.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Consistency:</strong><span style=\"color: rgb(55, 65, 81);\"> The displayed inventory data should be consistent with other related modules or systems to avoid confusion or discrepancies.</span></p><p><span style=\"color: rgb(55, 65, 81);\">5.    </span><strong style=\"color: rgb(55, 65, 81);\">Real-Time Updates:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should ensure that the inventory data is updated in real-time or with a minimum delay to reflect any recent changes in stock levels.</span></p><p><span style=\"color: rgb(55, 65, 81);\">6.    </span><strong style=\"color: rgb(55, 65, 81);\">Error Handling:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should handle errors gracefully and provide meaningful error messages when encountering issues like data retrieval failures or connectivity problems.</span></p><p><span style=\"color: rgb(55, 65, 81);\">7.    </span><strong style=\"color: rgb(55, 65, 81);\">Search Precision:</strong><span style=\"color: rgb(55, 65, 81);\"> The search functionality should accurately retrieve relevant inventory items based on the entered keywords or criteria.</span></p><p><span style=\"color: rgb(55, 65, 81);\">8.    </span><strong style=\"color: rgb(55, 65, 81);\">Sorting and Filtering:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should allow sorting and filtering of inventory data based on various attributes like product name, category, location, stock levels, etc.</span></p><p><span style=\"color: rgb(55, 65, 81);\">9.    </span><strong style=\"color: rgb(55, 65, 81);\">Low Stock Alerts:</strong><span style=\"color: rgb(55, 65, 81);\"> The system should generate alerts or notifications when inventory items reach critical stock levels or reorder points, allowing the Inventory Manager to take necessary actions.</span></p><p><span style=\"color: rgb(55, 65, 81);\">10. </span><strong style=\"color: rgb(55, 65, 81);\">Data Presentation:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should present inventory data in a clear, organized, and user-friendly format, making it easy for the Inventory Manager to understand and analyze the stock information.</span></p><p><span style=\"color: rgb(55, 65, 81);\">11. </span><strong style=\"color: rgb(55, 65, 81);\">Support for Large Inventories:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should be capable of handling and displaying data for a large number of inventory items without performance issues.</span></p><p><span style=\"color: rgb(55, 65, 81);\">12. </span><strong style=\"color: rgb(55, 65, 81);\">Concurrency Control:</strong><span style=\"color: rgb(55, 65, 81);\"> The system should handle concurrent access to inventory data by multiple users without data conflicts or integrity issues.</span></p><p><span style=\"color: rgb(55, 65, 81);\">13. </span><strong style=\"color: rgb(55, 65, 81);\">Compatibility:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should be compatible with different devices and browsers commonly used by the Inventory Manager.</span></p><p><span style=\"color: rgb(55, 65, 81);\">14. </span><strong style=\"color: rgb(55, 65, 81);\">Data Privacy:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature should ensure the privacy and security of sensitive inventory data, complying with data protection regulations.</span></p><p><span style=\"color: rgb(55, 65, 81);\">15. </span><strong style=\"color: rgb(55, 65, 81);\">Internationalization and Localization:</strong><span style=\"color: rgb(55, 65, 81);\"> If the Inventory Manager operates in multiple regions, the feature should support internationalization and localization to cater to various languages and regional preferences.</span></p><p><span style=\"color: rgb(55, 65, 81);\">16. </span><strong style=\"color: rgb(55, 65, 81);\">Offline Capability (if applicable):</strong><span style=\"color: rgb(55, 65, 81);\"> If the feature needs to work in offline mode, it should have mechanisms to store and synchronize data once the connection is restored.</span></p><p><span style=\"color: rgb(55, 65, 81);\">By considering these conditions, the \"View Inventory Stock\" feature can be designed and implemented to function effectively and meet the specific requirements of the Inventory Manager, guaranteeing stock quantity and integrity.</span></p><p><br></p>"
    },
    {
      question: "What are the potential issues to look for the feature?",
      answer: "<p><span style=\"color: rgb(55, 65, 81);\">When implementing the \"View Inventory Stock\" feature, there are several potential issues that should be carefully considered to ensure its functionality and reliability. Some of the key issues to look for include:</span></p><p><span style=\"color: rgb(55, 65, 81);\">1.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Inaccuracies:</strong><span style=\"color: rgb(55, 65, 81);\"> Inaccurate inventory data can lead to incorrect stock levels being displayed, potentially resulting in stockouts or overstocking.</span></p><p><span style=\"color: rgb(55, 65, 81);\">2.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Synchronization:</strong><span style=\"color: rgb(55, 65, 81);\"> If the inventory data is not synchronized properly with the actual stock levels in real-time, discrepancies can occur between what is displayed and what is physically available.</span></p><p><span style=\"color: rgb(55, 65, 81);\">3.    </span><strong style=\"color: rgb(55, 65, 81);\">Performance Bottlenecks:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature may experience performance issues, especially when dealing with a large number of inventory items or concurrent users accessing the system simultaneously.</span></p><p><span style=\"color: rgb(55, 65, 81);\">4.    </span><strong style=\"color: rgb(55, 65, 81);\">Security Vulnerabilities:</strong><span style=\"color: rgb(55, 65, 81);\"> Insufficient security measures can result in unauthorized access to sensitive inventory data, leading to potential data breaches and compromises.</span></p><p><span style=\"color: rgb(55, 65, 81);\">5.    </span><strong style=\"color: rgb(55, 65, 81);\">Error Handling:</strong><span style=\"color: rgb(55, 65, 81);\"> Inadequate error handling and error messages may confuse users and make it challenging to troubleshoot issues effectively.</span></p><p><span style=\"color: rgb(55, 65, 81);\">6.    </span><strong style=\"color: rgb(55, 65, 81);\">Low Stock Alerts:</strong><span style=\"color: rgb(55, 65, 81);\"> Failure to generate timely alerts for low stock levels may lead to stockouts and affect the ability to meet customer demands.</span></p><p><span style=\"color: rgb(55, 65, 81);\">7.    </span><strong style=\"color: rgb(55, 65, 81);\">Compatibility Issues:</strong><span style=\"color: rgb(55, 65, 81);\"> The feature may not work as expected on certain devices, browsers, or operating systems, causing usability problems for Inventory Managers.</span></p><p><span style=\"color: rgb(55, 65, 81);\">8.    </span><strong style=\"color: rgb(55, 65, 81);\">Data Integrity:</strong><span style=\"color: rgb(55, 65, 81);\"> Data integrity issues can arise if there are problems with data input, storage, or retrieval, leading to inconsistent or invalid inventory information.</span></p><p><span style=\"color: rgb(55, 65, 81);\">9.    </span><strong style=\"color: rgb(55, 65, 81);\">Usability Concerns:</strong><span style=\"color: rgb(55, 65, 81);\"> A poorly designed user interface may make it difficult for Inventory Managers to navigate and efficiently view inventory data.</span></p><p><span style=\"color: rgb(55, 65, 81);\">10. </span><strong style=\"color: rgb(55, 65, 81);\">Data Privacy Compliance:</strong><span style=\"color: rgb(55, 65, 81);\"> If the feature handles sensitive data, there may be concerns related to data privacy and compliance with relevant regulations.</span></p><p><span style=\"color: rgb(55, 65, 81);\">11. </span><strong style=\"color: rgb(55, 65, 81);\">Concurrency Control:</strong><span style=\"color: rgb(55, 65, 81);\"> Concurrent access by multiple Inventory Managers may result in conflicts or data inconsistencies if proper concurrency control mechanisms are not in place.</span></p><p><span style=\"color: rgb(55, 65, 81);\">12. </span><strong style=\"color: rgb(55, 65, 81);\">Reporting and Exporting:</strong><span style=\"color: rgb(55, 65, 81);\"> Issues related to data exporting and reporting functionality could hinder the Inventory Manager's ability to analyze and share inventory data.</span></p><p><span style=\"color: rgb(55, 65, 81);\">13. </span><strong style=\"color: rgb(55, 65, 81);\">Search and Filtering Problems:</strong><span style=\"color: rgb(55, 65, 81);\"> Inaccurate or ineffective search and filtering options may hinder Inventory Managers from quickly finding specific inventory items.</span></p><p><span style=\"color: rgb(55, 65, 81);\">14. </span><strong style=\"color: rgb(55, 65, 81);\">Audit Trail Accuracy:</strong><span style=\"color: rgb(55, 65, 81);\"> The audit trail should accurately record inventory view activities, ensuring accountability and traceability.</span></p><p><span style=\"color: rgb(55, 65, 81);\">15. </span><strong style=\"color: rgb(55, 65, 81);\">Mobile Responsiveness:</strong><span style=\"color: rgb(55, 65, 81);\"> If the feature is intended for use on mobile devices, issues related to responsiveness and mobile-friendly design need to be addressed.</span></p><p><span style=\"color: rgb(55, 65, 81);\">16. </span><strong style=\"color: rgb(55, 65, 81);\">Integration Challenges:</strong><span style=\"color: rgb(55, 65, 81);\"> If the feature needs to integrate with other systems, issues related to data exchange and compatibility may arise.</span></p><p><span style=\"color: rgb(55, 65, 81);\">To mitigate these potential issues, thorough testing, user feedback, and iterative improvements are essential throughout the development process. Regular maintenance and updates should also be performed to address any emerging issues and to keep the feature running smoothly and effectively.</span></p>"
    },
    {
      question: "What could be the Acceptance Criteria for the feature?",
      answer: "<p><span style=\"color: rgb(55, 65, 81);\">Acceptance criteria define the specific conditions that must be met for the \"View Inventory Stock\" feature to be considered complete and acceptable by the stakeholders, particularly the Inventory Manager. The acceptance criteria help ensure that the feature meets the intended functionality and quality standards. Here are some potential acceptance criteria for the feature:</span></p><ol><li><strong>Access and Authentication:</strong></li><li class=\"ql-indent-1\">The feature allows only authenticated Inventory Managers to access the \"View Inventory Stock\" functionality.</li><li class=\"ql-indent-1\">Inventory Managers can log in using their unique credentials.</li><li><strong>Inventory Data Display:</strong></li><li class=\"ql-indent-1\">The feature displays a list of all available inventories with relevant details, such as product name, SKU, and stock quantity.</li><li class=\"ql-indent-1\">The displayed inventory data accurately reflects the actual physical stock levels.</li><li><strong>Real-time Data Updates:</strong></li><li class=\"ql-indent-1\">The displayed inventory data updates in real-time or within a reasonable time frame after any stock changes occur.</li><li><strong>Search Functionality:</strong></li><li class=\"ql-indent-1\">The feature provides a search bar that allows Inventory Managers to find specific inventory items by entering keywords or SKU numbers.</li><li class=\"ql-indent-1\">The search results are accurate and relevant, matching the entered search criteria.</li><li><strong>Sorting and Filtering:</strong></li><li class=\"ql-indent-1\">Inventory Managers can sort the inventory data based on different attributes such as product name, category, and stock quantity.</li><li class=\"ql-indent-1\">The feature supports filtering inventory items based on various criteria, such as location, supplier, or stock availability.</li><li><strong>Stock Availability Indicators:</strong></li><li class=\"ql-indent-1\">The feature clearly indicates the availability status of each inventory item (e.g., in stock, out of stock, on order).</li><li class=\"ql-indent-1\">Low stock items are highlighted or marked to draw the Inventory Manager's attention.</li><li><strong>Low Stock Alerts:</strong></li><li class=\"ql-indent-1\">The system generates alerts or notifications when inventory items reach predetermined low stock levels or reorder points.</li><li><strong>Data Privacy and Security:</strong></li><li class=\"ql-indent-1\">The feature ensures that only authorized Inventory Managers can view the inventory data.</li><li class=\"ql-indent-1\">Sensitive inventory information is protected from unauthorized access or data breaches.</li><li><strong>User Interface Usability:</strong></li><li class=\"ql-indent-1\">The user interface is intuitive, easy to navigate, and provides a positive user experience for Inventory Managers.</li><li><strong>Data Export and Reporting:</strong></li><li class=\"ql-indent-1\">The feature allows Inventory Managers to export inventory data in commonly used formats like CSV or Excel for further analysis or reporting.</li><li><strong>Performance and Scalability:</strong></li><li class=\"ql-indent-1\">The feature performs well even with large inventories and concurrent user access.</li><li><strong>Audit Trail:</strong></li><li class=\"ql-indent-1\">The system maintains an accurate and complete audit trail of inventory view activities, recording who accessed the data and when.</li><li><strong>Compatibility:</strong></li><li class=\"ql-indent-1\">The feature works seamlessly on different devices, browsers, and operating systems commonly used by Inventory Managers.</li><li><strong>Accessibility:</strong></li><li class=\"ql-indent-1\">The feature meets accessibility standards to ensure that all users, including those with disabilities, can use it effectively.</li></ol><p><span style=\"color: rgb(55, 65, 81);\">These acceptance criteria provide clear guidelines for the development team and stakeholders to evaluate the completeness and quality of the \"View Inventory Stock\" feature. By meeting these criteria, the feature will effectively address the needs of the Inventory Manager and guarantee stock quantity and integrity.</span></p><p><br></p>"
    },
    {
      question: "What could be the Scenarios for the feature?",
      answer: "<p><span style=\"color: rgb(55, 65, 81);\">Acceptance criteria define the specific conditions that must be met for the \"View Inventory Stock\" feature to be considered complete and acceptable by the stakeholders, particularly the Inventory Manager. The acceptance criteria help ensure that the feature meets the intended functionality and quality standards. Here are some potential acceptance criteria for the feature:</span></p><ol><li><strong>Access and Authentication:</strong></li><li class=\"ql-indent-1\">The feature allows only authenticated Inventory Managers to access the \"View Inventory Stock\" functionality.</li><li class=\"ql-indent-1\">Inventory Managers can log in using their unique credentials.</li><li><strong>Inventory Data Display:</strong></li><li class=\"ql-indent-1\">The feature displays a list of all available inventories with relevant details, such as product name, SKU, and stock quantity.</li><li class=\"ql-indent-1\">The displayed inventory data accurately reflects the actual physical stock levels.</li><li><strong>Real-time Data Updates:</strong></li><li class=\"ql-indent-1\">The displayed inventory data updates in real-time or within a reasonable time frame after any stock changes occur.</li><li><strong>Search Functionality:</strong></li><li class=\"ql-indent-1\">The feature provides a search bar that allows Inventory Managers to find specific inventory items by entering keywords or SKU numbers.</li><li class=\"ql-indent-1\">The search results are accurate and relevant, matching the entered search criteria.</li><li><strong>Sorting and Filtering:</strong></li><li class=\"ql-indent-1\">Inventory Managers can sort the inventory data based on different attributes such as product name, category, and stock quantity.</li><li class=\"ql-indent-1\">The feature supports filtering inventory items based on various criteria, such as location, supplier, or stock availability.</li><li><strong>Stock Availability Indicators:</strong></li><li class=\"ql-indent-1\">The feature clearly indicates the availability status of each inventory item (e.g., in stock, out of stock, on order).</li><li class=\"ql-indent-1\">Low stock items are highlighted or marked to draw the Inventory Manager's attention.</li><li><strong>Low Stock Alerts:</strong></li><li class=\"ql-indent-1\">The system generates alerts or notifications when inventory items reach predetermined low stock levels or reorder points.</li><li><strong>Data Privacy and Security:</strong></li><li class=\"ql-indent-1\">The feature ensures that only authorized Inventory Managers can view the inventory data.</li><li class=\"ql-indent-1\">Sensitive inventory information is protected from unauthorized access or data breaches.</li><li><strong>User Interface Usability:</strong></li><li class=\"ql-indent-1\">The user interface is intuitive, easy to navigate, and provides a positive user experience for Inventory Managers.</li><li><strong>Data Export and Reporting:</strong></li><li class=\"ql-indent-1\">The feature allows Inventory Managers to export inventory data in commonly used formats like CSV or Excel for further analysis or reporting.</li><li><strong>Performance and Scalability:</strong></li><li class=\"ql-indent-1\">The feature performs well even with large inventories and concurrent user access.</li><li><strong>Audit Trail:</strong></li><li class=\"ql-indent-1\">The system maintains an accurate and complete audit trail of inventory view activities, recording who accessed the data and when.</li><li><strong>Compatibility:</strong></li><li class=\"ql-indent-1\">The feature works seamlessly on different devices, browsers, and operating systems commonly used by Inventory Managers.</li><li><strong>Accessibility:</strong></li><li class=\"ql-indent-1\">The feature meets accessibility standards to ensure that all users, including those with disabilities, can use it effectively.</li></ol><p><span style=\"color: rgb(55, 65, 81);\">These acceptance criteria provide clear guidelines for the development team and stakeholders to evaluate the completeness and quality of the \"View Inventory Stock\" feature. By meeting these criteria, the feature will effectively address the needs of the Inventory Manager and guarantee stock quantity and integrity.</span></p><p><br></p>"
    }
  ]
  listOfAttributesDB = [
    {
      name: "Migration",
      symbol: "Mi",
      level: "L8"
    },
    {
      name: "Installation",
      symbol: "In",
      level: "L8"
    },
    {
      name: "Configuration",
      symbol: "Co",
      level: "L8"
    },
    {
      name: "System Integration",
      symbol: "Si",
      level: "L8"
    },
    {
      name: "Performance",
      symbol: "Pf",
      level: "L7"
    },
    {
      name: "Load",
      symbol: "Lo",
      level: "L7"
    },
    {
      name: "Reliability",
      symbol: "Re",
      level: "L7"
    },
    {
      name: "Security",
      symbol: "Se",
      level: "L7"
    },
    {
      name: "Usability",
      symbol: "Us",
      level: "L7"
    },
    {
      name: "Browser Compatibility",
      symbol: "Bc",
      level: "L6"
    },
    {
      name: "Environment Compatibility",
      symbol: "Ec",
      level: "L6"
    },
    {
      name: "Requirement Behaviour",
      symbol: "Rb",
      level: "L5"
    },
    {
      name: "Flow Behaviour",
      symbol: "Fb",
      level: "L5"
    },
    {
      name: "Feature Behaviour",
      symbol: "Fe",
      level: "L4"
    },
    {
      name: "Access Control",
      symbol: "Ac",
      level: "L4"
    },
    {
      name: "UI Interface",
      symbol: "Ui",
      level: "L123"
    },
    {
      name: "Structural Behaviour",
      symbol: "St",
      level: "L123"
    },
    // {
    //   name: "Data Validation",
    //   symbol: "Dt",
    //   level: "L123"
    // },
  ]

  listOfAttributesNew = [
    {
      "aType": "Load & Stress (Ls)",
      "aDetail": "",
      "placeholder": "Expectations on typical/max load and extreme(stress)"
    },
    {
      "aType": "Performance (Pf)",
      "aDetail": "",
      "placeholder": "Response time(time)or throughput (#/time)"
    },
    {
      "aType": "Security (Se)",
      "aDetail": "",
      "placeholder": "Expectations on security of storage and transfer of data"
    },
    {
      "aType": "Usability (Us)",
      "aDetail": "",
      "placeholder": "Expectations on ease of usage of the system"
    },
    {
      "aType": "Compatibility(Cm)",
      "aDetail": "",
      "placeholder": "Expectations of various environments to support(HW/SW)"
    },
    {
      "aType": "Volume (Vo)",
      "aDetail": "",
      "placeholder": "Large data handling size requirements"
    },
    {
      "aType": "Reliability (Re)",
      "aDetail": "",
      "placeholder": "Expectations on time duration of no major failures(down/up time)"
    },
    {
      "aType": "Migration (Mi)",
      "aDetail": "",
      "placeholder": "Expectations of what earlier versions to be migrated"
    }
  ]
  listOfTestTypes = [
    {
      name: "Performance",
      symbol: "Pf",
      level: "L7"
    },
    {
      name: "Load",
      symbol: "Lo",
      level: "L7"
    },
    {
      name: "Volume",
      symbol: "Vo",
      level: "L7"
    },
    {
      name: "Security",
      symbol: "Se",
      level: "L7"
    },
    {
      name: "Usability",
      symbol: "Us",
      level: "L7"
    },
  ]

  scopeMap = []

  entityDefaultNotes = '<p>@personas</p><p><br></p><p><br></p><p>@attributes</p><p><br></p><p><br></p><p>@observations</p><p><br></p><p><br></p><p>@issues</p><p><br></p><p><br></p><p>@questions</p><p><br></p><p><br></p><p>@suggestions</p><p><br></p><p><br></p>';

  assistantMessages = [{
    "role": "system",
    "content": "You are an experienced software tester. You will be provided with some textual description and your task is to answer the questions pertaining to that text. Give brief and direct answers to the questions. If you are unsure about an answer, say you don't know rather than guessing and giving an incorrect answer. If you are asked to give the answer in the form of an enumerated list, mention the title for each element of the list where necessary, but do not add any punctuation or special character before and after the title. For example, the following are valid list element formats: 1) Possible scenario: <some text> 2) <some text> The following are not valid list element formats: 1) * Possible scenario *: <some text> 2) ++Possible scenario++: <some text> Always use active voice instead of passive voice, unless you are specifically asked to use passive voice. Finally, if you are asked any question that is not related to the area of software testing, politely point out that the question is outside the scope of present discussion and don't answer that question."
  }]
  assistantChatRECON = {
    "tool": "RECON",
    "messages": []
  };
  assistantChat = [
    {
      "tool": "ET-LS",
      "choices": [
        {
          "_id": "GPT-225e-39e3-665e-fc4a-c32fd2c5e4e5",
          "query": "Who are the potential users of the feature?",
          "accessed": false,
          "type": "PU",
          "messages": [
            {
              "role": "user",
              "content": "Who are the potential users of the feature?"
            }
          ]
        },
        {
          "_id": "GPT-96cb-ef74-7b30-cb54-089801d8fc73",
          "query": "What are the non-functional attributes of the feature?",
          "accessed": false,
          "type": "FA",
          "messages": [
            {
              "role": "user",
              "content": "What are the non-functional attributes of the feature?"
            }
          ]
        }
      ]
    },
    {
      "tool": "ET-DD",
      "choices": [
        {
          "_id": "GPT-b106-b51c-af30-c36d-6693f9ebb343",
          "query": "What are the possible acceptance criteria of the feature?",
          "accessed": false,
          "type": "AC",
          "messages": [
            {
              "role": "user",
              "content": "What are the possible acceptance criteria of the feature?"
            }
          ]
        },
        {
          "_id": "GPT-13b1-d99b-3a6f-1be7-daf71fe201cb",
          "query": "What are the Behavioural conditions of the feature?",
          "accessed": false,
          "type": "BC",
          "messages": [
            {
              "role": "user",
              "content": "What are the Behavioural conditions of the feature?"
            }
          ]
        },
        {
          "_id": "GPT-a601-4203-d4d1-9736-80992a4f687c",
          "query": "What are the Potential issues of the feature?",
          "accessed": false,
          "type": "PI",
          "messages": [
            {
              "role": "user",
              "content": "What are the Potential issues of the feature?"
            }
          ]
        },
        {
          "_id": "GPT-e235-c658-b554-f918-d618b3fc736d",
          "query": "What are the Inputs & outputs of the feature?",
          "accessed": false,
          "type": "IO",
          "messages": [
            {
              "role": "user",
              "content": "What are the Inputs & outputs of the feature?"
            }
          ]
        }
      ]
    },
    {
      "tool": "ET-DE",
      "choices": [
        {
          "_id": "GPT-d05d-8da9-9d2e-f05d-8c2f79a0ae61",
          "query": "What are the functional Scenarios of the feature?",
          "accessed": false,
          "type": "FS",
          "messages": [
            {
              "role": "user",
              "content": "What are the Scenarios of the feature?"
            }
          ]
        },
        {
          "_id": "GPT-3e4f-3707-df69-2593-4e27b8822648",
          "query": "What are the non-functional scenarios of the feature?",
          "accessed": false,
          "type": "NFS",
          "messages": [
            {
              "role": "user",
              "content": "What are the non-functional scenarios of the feature?"
            }
          ]
        }
      ]
    },
  ]
  // GPT-613c-a691-ac34-ac9d-796a7a9a2a1c
  // GPT-8aaf-5ace-0a69-0134-7b93f32d55de
  // GPT-ea33-de67-a422-3d1c-026f5d1b9066
  // GPT-fcda-5021-8d24-7db0-e6ada9fd7148
  // GPT-369d-a1b7-0d32-c075-87702ce41216
}
